import { memo } from 'react';
import { ActionCable } from 'react-actioncable-provider';
import notificationRingtone from 'assets/audio/notifcation.mp3';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { connect } from 'react-redux';

const NotificationsSound = forwardRef((props, ref) => {
  const [playMusic, setPlayMusic] = useState(false);
  const audio = new Audio(notificationRingtone);
  const audiRef = useRef();

  useImperativeHandle(ref, () => ({
    setTrue() {
      setPlayMusic(true);
      (async () => {
        try {
          await audio.play();
        } catch (e) {
          console.log('Play audio error', e);
        }
      })();
    }
  }));

  useEffect(() => {
    if (playMusic) {
      setTimeout(() => {
        setPlayMusic(false);
      }, 1500);
    }
  }, [playMusic]);

  return (
    <>
      <audio
        ref={audiRef}
        src={notificationRingtone}
        // autoPlay={true}
        onError={(e) => console.log('e ', e)}
      />
    </>
  );
});

const Notifications = ({ currentRestaurant }) => {
  const childRef = useRef();

  const handleReceivedConversation = (response) => {
    const { message } = response;
    console.log('response', response);
    childRef.current?.setTrue();
  };

  if (!currentRestaurant?.id) {
    return <></>;
  }

  return (
    <>
      <ActionCable
        channel={{
          channel: 'RestaurantsChannel',
          restaurant_id: currentRestaurant?.id,
        }}
        onReceived={handleReceivedConversation}
      />
      <NotificationsSound ref={childRef} />
    </>
  );
};

const mapStateToProps = state => ({
  currentRestaurant: state.common.currentRestaurant,
});

export default connect(mapStateToProps)(memo(Notifications));
